import { Popover, Radio } from 'antd';
import type {ActionType} from 'rc-trigger/lib/interface';
import * as Icons from '@ant-design/icons'; 
import styles from './index.module.scss'

interface MultipleListsPopoverProps {
    items: Digital_Protocol_SoA_Table_Data.PopoverItemsList[]
    children: any
    idx: number
    onAction: (name: string, idx: number, activityItem: Digital_Protocol_SoA_Table_Data.Entity, condition: Digital_Protocol_SoA_Table_Data.Condition) => void
    activityItem?: Digital_Protocol_SoA_Table_Data.Entity
    visitType?: Digital_Protocol_SoA_Table_Data.VisitType[]
    period?: Digital_Protocol_SoA_Table_Data.PeriodData
    condition?: Digital_Protocol_SoA_Table_Data.Condition
    trigger?: ActionType | ActionType[]
    zIndex?: number
    visitChangeHandler?: (e: any, periodId: number) => void
    disabled?: boolean
}
  
export function MultipleListsPopover ({ items, children, onAction, idx, activityItem, visitType, period, condition, trigger, zIndex = 999, visitChangeHandler, disabled = false } : MultipleListsPopoverProps) {
    const content = (  
    <div>  
      {items.map((item, index) => {  
        const IconComponent = Icons[item.icon];
        return (  
          <div 
            key={index} 
            onClick={(e) => {
              e.stopPropagation()
              onAction(item.name, idx, activityItem, condition)
            } } 
            className={styles.item} 
            style={{ cursor: 'pointer', color: item.color, padding: '2px' }}
          >  
            {IconComponent && <IconComponent style={{ marginRight: 8 }} />}  
            {item.name}  

            {item.name === 'Period Type' && (
              <div>
                <Radio.Group  
                key={index}  
                onChange={(e) => {  
                  e.stopPropagation();  
                  visitChangeHandler(e, period?.period_id);  
                }}  
                value={period?.visit_type} 
                style={{ padding: '2px' }} >  
                {Array.isArray(visitType) && visitType?.map((visit, index) => ( 
                  <div>  
                    <Radio key={index} value={visit?.visit_type}>{visit?.visit_type}</Radio> 
                  </div>
                ))}
              </Radio.Group> 
              </div>
            )}
          </div>  
        );  
      })}  
    </div>  
    );  
    
    return (  
      <Popover content={content} trigger={trigger ?? "hover"} zIndex={zIndex} visible={disabled ? false : undefined}>
        {children}
      </Popover>  
    );  
  };  
export default MultipleListsPopover;  
